export class CQMSDashBoardCalcDispaly {
    measureId: number;
    measureName: string;
    dataCompletenessRatio: string;
    dataCompletenessNumDenom: string;
    dataPerformananceRatio: string;
    dataPerformananceNumDenom: string;
    patNumeratorList: PatInfo[];
    patDenominatorList: PatInfo[];
    patFailedList: PatInfo[];
}


export class MainCQMSDashBoardList {
    totalExemptedCount: string;
    totalMetCount: string;
    totalNotMetCount: string;
    totalFailedCount: string;
    MeasureID: string;
    MeasureName: string;
    DataCompletenessDenominator: string;
    DataCompletenessNumerator: string;
    DataCompletenessRatio: string;
    PerformanceRateDenominator: string;
    PerformanceRateNumerator: string;
    PerformanceRateRatio: string;
    // Per-status breakdown counts (measure-level), added for Quality ID #134 (Depression Screening)'s
    // dedicated dashboard section. Populated generically for every measure - see EncounterDao.GetMainCQMSDashBoardData.
    PerformanceMetCount: string;
    DenominatorExceptionCount: string;
    PerformanceNotMetCount: string;
    DataCompletenessNotMetCount: string;
    DenominatorExclusionCount: string;
}


export class PatInfo {
    patId: number;
    fullName: string;
    firstName: string;
    lastName: string;
    middleName: string;
    dob: string;
    age: string;
    gender: string;
    race: string;
    ethniCity: string;
    language: string;
    measureStatus: string;
    measureName: string;
    patIdD: number;
}
export class MainCQMSDashBoardPatMeasure extends PatInfo {
    MeasureId: number;
    ExemptedCount: number;
    FailedCount: number;
    NotMetCount: number;
    MetCount: number;
    selected?: boolean;
    DuplicateText?: string;
}
export class MainCQMSDashBoardEMRMeasure {

    MeasureId: number;
    MeasureName: string;
    PatId: number;
    VisitDate: Date;
    EncounterId: string;
    PatAge: number;
    CQMStatus: string;
    LocationName: string;
    locationid: number;
    ProviderId: string;
    ProviderName: string;

}

export class MainAllCQMSDashBoard {
    MainCQMSDashBoard: MainCQMSDashBoardList[];
    MainCQMSDashBoardPatMeasure: MainCQMSDashBoardPatMeasure[];
    MainCQMSDashBoardEMRMeasure: MainCQMSDashBoardEMRMeasure[];
}